import Pikaday from 'pikaday';

export function init() {
  const element = document.querySelector('.js-grocery-shipping-method');
  const deliveryDateInput = document.querySelector('.js-datepicker-delivery');

	if (!element) {
		return;
	}

	let date = new Date();
	date.setDate(date.getDate() + 1);

	const deliveryDateDatePicker = new Pikaday({
		theme: 'date-picker',
		field: deliveryDateInput,
		toString(selectedDate) {
			const year = selectedDate.getFullYear();
			const month = `${selectedDate.getMonth() + 1}`;
			const day = `${selectedDate.getDate()}`;
			return [year, month, day].join('-');
		},
		parse(dateString) {
			const parts = dateString.split('-');
			const year = parseInt(parts[0], 10);
			const month = parseInt(parts[1], 10) - 1;
			const day = parseInt(parts[2], 10);

			return new Date(year, month, day);
		},
		disableDayFn: function disableDay(date) {
			return date.getDay() === 0;
		},
		keyboardInput: false,
		minDate: date,
	});

	deliveryDateInput.setAttribute('inputmode', 'none');
	deliveryDateInput.setAttribute('readonly', 'readonly');
}
